/**
 * VisualChecksList — per-check status pill + comment. Used by visual-analysis
 * prompts where the LLM evaluates diagrams (graphs, FBDs, geometry).
 * Stateless atom; renders nothing when no checks are present.
 */
import { LatexText } from '../../latex';
import type { VisualCheck } from '@padcanvas/shared';

interface Props {
    items: readonly VisualCheck[] | undefined;
    title?: string;
}

export function VisualChecksList({ items, title = 'Visual Checks' }: Props) {
    if (!items || items.length === 0) return null;
    return (
        <section className="sol-section sol-visual-checks">
            <h3 className="sol-section-title">{title}</h3>
            <ul className="sol-visual-checks-list">
                {items.map((c, i) => (
                    <li key={i} className={`sol-visual-check status-${c.status}`}>
                        <span className={`sol-visual-check-status sol-visual-check-status-${c.status}`}>{c.status}</span>
                        <span className="sol-visual-check-name">{c.check}</span>
                        {c.comment && <span className="sol-visual-check-comment"><LatexText text={c.comment} /></span>}
                    </li>
                ))}
            </ul>
        </section>
    );
}
